import { unsafeCSS as y, LitElement as k, html as m } from "lit";
import { property as p } from "lit/decorators.js";
import { classMap as c } from "lit/directives/class-map.js";
const v = (i) => {
  class t extends i {
    constructor(...a) {
      super(...a), this.fontLink = "https://www.aa.com/fonts/css/family/american-sans-variable.css";
      const r = document.head || document.getElementsByTagName("head")[0];
      if (Array.from(r.getElementsByTagName("link")).findIndex(
        (l) => l.href === this.fontLink
      ) === -1) {
        const l = document.createElement("link");
        l.href = this.fontLink, l.rel = "stylesheet", document.head.appendChild(l);
      }
    }
  }
  return t;
}, x = '*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}strong{font-weight:700;font-variation-settings:"wght" 700}.static{position:static}.inline{display:inline}[hidden]{display:none!important}', S = y(x), h = "aileron-color-scheme", f = "aileron-color-scheme-change", C = (i) => {
  const e = class e extends i {
    constructor() {
      super(...arguments), this.handleSchemeSwitch = (r) => {
        r.detail ? this.setAttribute(h, r.detail) : this.removeAttribute(h);
      };
    }
    /**
     * Init web component with listener for theme changes, and gets current theme state.
     */
    connectedCallback() {
      super.connectedCallback(), document.documentElement.addEventListener(
        f,
        this.handleSchemeSwitch,
        {
          passive: !0
        }
      );
      const r = document.documentElement.getAttribute(
        h
      );
      r && this.setAttribute(h, r);
    }
    disconnectedCallback() {
      super.disconnectedCallback(), document.documentElement.removeEventListener(
        f,
        this.handleSchemeSwitch
      );
    }
  };
  e.styles = [
    S,
    i.styles ?? []
  ];
  let t = e;
  return t;
}, b = C(v(k));
class z {
  constructor(t, ...e) {
    this.slotNames = [], (this.host = t).addController(this), this.slotNames = e, this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  hasDefaultSlot() {
    return Array.from(this.host.childNodes).some((t) => {
      var e;
      if (t.nodeType === t.TEXT_NODE && ((e = t.textContent) == null ? void 0 : e.trim()) !== "")
        return !0;
      if (t.nodeType === t.ELEMENT_NODE) {
        const a = t;
        if (a.tagName.toLowerCase() === "adc-visually-hidden")
          return !1;
        if (!a.hasAttribute("slot"))
          return !0;
      }
      return !1;
    });
  }
  hasNamedSlot(t) {
    return this.host.querySelector(`:scope > [slot="${t}"]`) !== null;
  }
  test(t) {
    return t === "[default]" ? this.hasDefaultSlot() : this.hasNamedSlot(t);
  }
  hostConnected() {
    var t;
    (t = this.host.shadowRoot) == null || t.addEventListener("slotchange", this.handleSlotChange);
  }
  hostDisconnected() {
    var t;
    (t = this.host.shadowRoot) == null || t.removeEventListener(
      "slotchange",
      this.handleSlotChange
    );
  }
  handleSlotChange(t) {
    var a, r;
    const e = t.target;
    ((a = this.slotNames) != null && a.includes("[default]") && !e.name || e.name && ((r = this.slotNames) != null && r.includes(e.name))) && this.host.requestUpdate();
  }
}
const E = "@media (prefers-color-scheme: dark){:host([aileron-color-scheme=dark]) .adc-divider{display:inline-flex}:host([aileron-color-scheme=dark]) .adc-divider-color-default{border-color:#869199}:host([aileron-color-scheme=dark]) .adc-divider-color-secondary{border-color:#4d5e6c}:host([aileron-color-scheme=dark]) .adc-divider-color-tertiary{border-color:#3c4e5f}}.aileron-divider{display:flex;flex-direction:row;align-items:center;margin-block:12px;border-color:#869199;font-size:14px;line-height:20px}.aileron-divider--secondary{border-color:#d0dae0!important}.aileron-divider--tertiary{border-color:#e6ecef!important}.aileron-divider--dashed{border-style:dashed}.aileron-divider--24{margin-block:24px}.aileron-divider--32{margin-block:32px}.aileron-divider--40{margin-block:40px}.aileron-divider--48{margin-block:48px}.aileron-divider--64{margin-block:64px}.aileron-divider__hr-leading,.aileron-divider__hr-trailing{flex-grow:1;border-top-width:1px;border-color:#869199}.aileron-divider__hr-leading{margin-right:.5rem}.aileron-divider__hr-trailing{margin-left:.5rem}";
var $ = Object.defineProperty, w = (i, t, e, a) => {
  for (var r = void 0, d = i.length - 1, u; d >= 0; d--)
    (u = i[d]) && (r = u(t, e, r) || r);
  return r && $(t, e, r), r;
};
const n = "aileron-divider", o = {
  root: n,
  hrLeading: `${n}__hr-leading`,
  hrTrailing: `${n}__hr-trailing`,
  secondary: `${n}--secondary`,
  tertiary: `${n}--tertiary`,
  spacing24: `${n}--24`,
  spacing32: `${n}--32`,
  spacing40: `${n}--40`,
  spacing48: `${n}--48`,
  spacing64: `${n}--64`,
  dashed: `${n}--dashed`
}, g = class g extends b {
  constructor() {
    super(...arguments), this.hasSlotController = new z(this), this.dashed = !1, this.size = "small", this.spacing = "12", this.color = "default";
  }
  async connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-divider");
  }
  firstUpdated() {
    var t;
    if (this.hasSlotController.test("[default]")) {
      const e = (t = this.shadowRoot) == null ? void 0 : t.querySelector("slot"), a = e == null ? void 0 : e.assignedElements();
      a == null || a.forEach(
        (r) => r.setAttribute("role", "presentation")
      );
    }
  }
  render() {
    return this.hasSlotController.test("[default]") ? m`
      <div
        part="divider"
        role="separator"
        class=" ${c(
      {
        [o.root]: !0,
        [o[`spacing${this.spacing}`]]: this.spacing !== "12"
      }
    )}"
      >
      <div class="${c(
      {
        [o.hrLeading]: !0,
        [o.secondary]: this.color === "secondary",
        [o.tertiary]: this.color === "tertiary",
        [o.dashed]: this.dashed
      }
    )}"></div>
        <slot></slot>
        <div class="${c(
      {
        [o.hrTrailing]: !0,
        [o.secondary]: this.color === "secondary",
        [o.tertiary]: this.color === "tertiary",
        [o.dashed]: this.dashed
      }
    )}"></div>
      </div>` : m`
    <hr
      part="divider"
      role="separator"
      class=" ${c(
      {
        [o.root]: !0,
        [o.secondary]: this.color === "secondary",
        [o.tertiary]: this.color === "tertiary",
        [o[`spacing${this.spacing}`]]: this.spacing !== "12",
        [o.dashed]: this.dashed
      }
    )}"
    />`;
  }
};
g.styles = [b.styles || [], y(E)];
let s = g;
w([
  p({ type: Boolean, reflect: !0 })
], s.prototype, "dashed");
w([
  p({ reflect: !0 })
], s.prototype, "size");
w([
  p({ reflect: !0 })
], s.prototype, "spacing");
w([
  p({ reflect: !0 })
], s.prototype, "color");
function L(i) {
  try {
    customElements.define(`${i}-divider`, class extends s {
    });
  } catch {
  }
}
try {
  customElements.define("adc-divider", s), console.warn("@aileron/divider is deprecated. Please use @aileron/lit-components instead. For migration documentation, see https://aileron.aa.com/components/divider");
} catch {
}
function T(i) {
  try {
    L(i);
  } catch {
  }
}
export {
  T as registerComponent,
  L as registerDivider
};
